import { render } from "./PopupWindow.vue?vue&type=template&id=8916e5f6&scoped=true"
import script from "./PopupWindow.vue?vue&type=script&lang=js"
export * from "./PopupWindow.vue?vue&type=script&lang=js"

import "./PopupWindow.vue?vue&type=style&index=0&id=8916e5f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8916e5f6"]])

export default __exports__